import type React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SuccessPoolIcon from '../assets/icons/success-pool.svg';
import AuthLayout from '../components/AuthLayout';
import AppButton from '../components/common/AppButton';
import Stepper from '../components/common/Stepper';
import { useAuth } from '../context/AuthContext';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { company } = useAuth();
  const checkoutHistory = company
    ? sessionStorage.getItem(`billing-returning-${company.id}`)
    : null;
  const returningSubscriber =
    checkoutHistory === 'true'
      ? true
      : checkoutHistory === 'false'
        ? false
        : typeof state?.returningSubscriber === 'boolean'
          ? state.returningSubscriber
          : undefined;
  return (
    <AuthLayout
      title={
        returningSubscriber === undefined
          ? 'Your subscription is active'
          : returningSubscriber
            ? 'Welcome back!'
            : 'Welcome to Pool Guy!'
      }
      subtitle="Your subscription is now active."
      multiColumn
      stepper={
        returningSubscriber === false ? (
          <Stepper
            steps={['Set up your company', 'Subscribe']}
            currentStep={2}
            completed
          />
        ) : undefined
      }
    >
      <div className="flex flex-col items-center text-center gap-8">
        <SuccessPoolIcon />
        <p className="text-xl font-semibold text-dark">
          {returningSubscriber === true
            ? 'You’re ready to get back to pool care.'
            : "It's time to make pool care easy."}
        </p>
        <div className="w-full md:px-10">
          <AppButton
            fullWidth
            onClick={() => {
              navigate('/', { replace: true });
            }}
          >
            Continue to app
          </AppButton>
        </div>
      </div>
    </AuthLayout>
  );
};

export default SubscriptionSuccessPage;
